import React, { useEffect } from "react";
import FormComponent from "./FormComponent";
import "./banner.css";
// import Aos from "aos";
// import "aos/dist/aos.css";

function Banner() {
    //     useEffect(() => {
    //     Aos.init({
    //       offset: 0,
    //     duration: 800,
    //     once: true,
    //     mirror: false,
    //     });

    //     // Refresh after DOM fully painted
    //     setTimeout(() => {
    //       Aos.refreshHard();
    //     }, 100);

    //   }, []);

    return (
        <>
            <section id="banner" className="position-relative">
                <div className="banner-wrap">
                    <div className="image-container">
                        <img src="dist/img/banner_desk.webp" width={700} height={562} alt="Banner" className="desk_banner" />
                    </div>

                    <div className="container-lg g-0 g-md-5">
                        <div className="row g-0 justify-content-center">
                            <div className="col-md-6 col-lg-7 col-xl-8 z-3 banner-wrapper">
                                <img src="dist/img/banner-mob.webp" width={700} height={562} alt="Banner" className="mob_banner" />
                                <div className="bannerlist px-3 px-lg-0 mt-md-0">
                                    <h1 data-aos="fade-up" data-aos-delay="100">
                                        Bank account <br />
                                        exclusively crafted <br />
                                        for Salaried  <br />
                                        Professionals

                                    </h1>
                                </div>
                                <div className="feat">
                                    <div data-aos="fade-up" data-aos-delay="500" className="border-r">
                                        <img src="dist/img/icons/banner-family.svg" width={40} height={53} alt="Dedicated" />
                                        <p>No minimum balance required</p>
                                    </div>
                                    <div data-aos="fade-up" data-aos-delay="700">
                                        <img src="dist/img/icons/banner-home.svg" width={52} height={52} alt="Amazon Pay ICICI Bank Credit Card" />
                                        <p>Pre-approved  <br /> instant loans</p>
                                    </div>
                                </div>
                                <div className="d-block d-md-none cta_banner">
                                    <a href="#benefits" className="btn">explore more benefits</a>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-5 col-xl-4  d-flex align-items-center">
                                <FormComponent></FormComponent>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    );
}

export default Banner;
